//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { IState } from 'angular-ui-router';

type TreeChangesPath = 'to' | 'from' /* | 'entering' | 'exiting' | 'retained' */;

/**
 * This class is a POLYFILL for forwards-compatibility with ui-router 1.0.
 * We can't currently upgrade to ui-router 1.0 because of https://github.com/angular-ui/ui-router/issues/3617
 * Class mimicks their `Transition` class and helps us simulate `redirectTo` behavior.
 */
export default class Transition {
  constructor(
        private readonly toState: IState,
        private readonly toParams: Record<string, unknown>,
        private readonly fromState: IState,
        private readonly fromParams: Record<string, unknown>,
    ) {
  }

  public $to() {
    return this.toState;
  }

  public to() {
    return this.toState;
  }
  public from() {
    return this.fromState;
  }
  public params(pathName: TreeChangesPath = 'to'): Record<string, unknown> {
    switch (pathName) {
      case 'to':
        return this.toParams;
      case 'from':
        return this.fromParams;
    }
  }
}
